module.exports = __webpack_public_path__ + "static/media/bts_lalela_170716_031_small.6d032d71.jpg";